export default __webpack_public_path__ + "static/favicon-06d89249739cc7a9622e417cb763f0f2.ico";